// extracted by mini-css-extract-plugin
module.exports = {"container":"_1S8Krdks1uoy97axK2hGXV","groupsList":"rbzBITpkzolhlCJYLmzZw"};